<!--
 * @Description: 主布局：白色顶栏 + 可折叠深色侧栏（2026-11 改版）
 * @FilePath: /sunpay-web/src/components/layout/horizontalIndex.vue
-->


<template>
  <el-container class="layout-main-container">
    <el-header class="layout-main-header" height="48px">
      <layout-header :collapsed="collapsed" @toggle-collapse="collapsed = !collapsed" />
    </el-header>
    <el-container class="sub-container">
      <el-aside class="side-aside" :class="{ 'is-collapsed': collapsed }">
        <div class="side-logo">
          <img class="logo-img" src="@/assets/imgs/logo.png" alt="logo" />
          <span v-show="!collapsed" class="logo-text">sunpay</span>
        </div>
        <top-menu :collapsed="collapsed"></top-menu>
      </el-aside>
      <el-main class="side-main">
        <tm-router-view></tm-router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script setup>
import { ref } from "vue";
import LayoutHeader from "./LayoutHeader";
import tmRouterView from "@/components/layout/RouterView.vue";
import TopMenu from "./TopMenu.vue";
const collapsed = ref(false);
</script>

<style lang="less" scoped>
.sub-container {
  padding: 0;
  height: calc(100% - @header-height);
}
.side-aside {
  width: @sidebar-width;
  background: @sidebar-bg;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: width 0.18s ease;
  &.is-collapsed {
    width: @sidebar-collapsed-width;
  }
}
.side-logo {
  height: @header-height;
  flex: 0 0 @header-height;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  overflow: hidden;
  white-space: nowrap;
  .logo-img {
    width: 26px;
    height: 26px;
    flex: 0 0 26px;
    object-fit: contain;
  }
  .logo-text {
    color: #fff;
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 0.3px;
  }
}
.side-main {
  padding: 0;
  background: @bg-page;
}
</style>
